import React, { useEffect } from "react";
import { connect } from "react-redux";
import Loader from "./../../../utilityComponents/Loader";
import PropTypes from "prop-types";
import { IndividualScenarioKPIEvaluation } from "./../../../actions/closeLoop/kpiDashboard/kpiEvaluationStatusAction";
import Alert from "react-bootstrap/Alert";

function KpiEvaluationStatus(props) {
    useEffect(() => {
        props.dispatch(
            IndividualScenarioKPIEvaluation(
                props.store.dashboardFilterData.info.selectData.scenarioId
            )
        );
    }, [props.store.dashboardFilterData.info.selectData.scenarioId]);
    console.log("kpistatus", props.kpiStatus);
    return (
        <div>
            <div
                className="card"
                style={{ border: "solid #757AF7", borderRadius: "0%" }}
            >
                <div
                    className="card-header"
                    style={{ backgroundColor: "#757AF7", color: "#FFFFFF" }}
                >
                    <div className="row">
                        <div className="col-12 align-self-center">
                            Test Run Validation Status Report{" "}
                        </div>
                    </div>
                </div>
                {props.kpiStatusLoading ? (
                    <Loader />
                ) : props.kpiStatusError ? (
                    <Alert variant="danger">
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                                fontWeight: "bold",
                                fontSize: "20px",
                            }}
                        >
                            {props.errorMessage}
                        </p>
                    </Alert>
                ) : (
                    <div className="card-body">
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr
                                        className="table-head"
                                        valign="middle"
                                        align="middle"
                                    >
                                        <th
                                            scope="col"
                                            key="kpi"
                                            style={{ textAlign: "center" }}
                                        >
                                            KPI
                                        </th>
                                        <th
                                            scope="col"
                                            key="status"
                                            style={{ textAlign: "center" }}
                                        >
                                            Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        key="13"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L1 Lateral Acceleration KPI</td>
                                        {props.kpiStatus
                                            .l1_lateral_acceleration ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="14"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L1 Lateral Jerk KPI</td>
                                        {props.kpiStatus.l1_lateral_jerk ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="15"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>
                                            L1 Longitudinal Deceleration KPI
                                        </td>
                                        {props.kpiStatus
                                            .l1_longitudinal_deceleration ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="16"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>
                                            L1 Longitudinal Acceleration KPI
                                        </td>
                                        {props.kpiStatus
                                            .l1_longitudinal_acceleration ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="17"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L1 Longitudinal Jerk KPI</td>
                                        {props.kpiStatus
                                            .l1_longitudinal_jerk === "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="18"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>
                                            L1 Longitudinal Velocity Check KPI
                                        </td>
                                        {props.kpiStatus
                                            .l1_longitudinal_velocity_drop ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr
                                        key="5"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L0 Collision Check KPI</td>
                                        {props.kpiStatus.l0_collision_check ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="6"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L0 Lateral Safe Distance KPI</td>
                                        {props.kpiStatus
                                            .l0_lateral_safe_distance ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="7"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>
                                            L0 Longitudinal Safe Distance KPI
                                        </td>
                                        {props.kpiStatus
                                            .l0_longitudinal_safe_distance ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="8"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L0 Offroad Check KPI</td>
                                        {props.kpiStatus.l0_offroad_check ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="9"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L0 Lane Marking Check KPI</td>
                                        {props.kpiStatus
                                            .l0_lane_marking_check ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="10"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L0 Indicator Check KPI</td>
                                        {props.kpiStatus
                                            .l0_indicator_checking ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="11"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L0 Speed Limit Check KPI</td>
                                        {props.kpiStatus
                                            .l0_speed_limit_check === "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="12"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>L0 False Indicator Check KPI</td>
                                        {props.kpiStatus
                                            .l0_false_indicator_check ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr
                                        key="19"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>RSS Lateral Left Safe Check KPI</td>
                                        {props.kpiStatus
                                            .rss_lateral_left_safe_check ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="20"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>
                                            RSS Lateral Right Safe Check KPI
                                        </td>
                                        {props.kpiStatus
                                            .rss_lateral_right_safe_check ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                    <tr
                                        key="21"
                                        valign="middle"
                                        className="table-row"
                                        style={{
                                            verticalAlign: "text-top",
                                        }}
                                    >
                                        <td>RSS Longitudinal Safe Check KPI</td>
                                        {props.kpiStatus
                                            .rss_longitudinal_safe_check ===
                                        "pass" ? (
                                            <td style={{ color: "#428003" }}>
                                                Pass
                                            </td>
                                        ) : (
                                            <td style={{ color: "#622AD8" }}>
                                                Fail
                                            </td>
                                        )}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
// }

const mapStateToProps = (state) => {
    return {
        store: state,
        kpiStatus: state.KpiStatusReducer.data,
        kpiStatusLoading: state.KpiStatusReducer.loading,
        kpiStatusError: state.KpiStatusReducer.error,
        errorMessage: state.KpiStatusReducer.errorMessage
    };
};

KpiEvaluationStatus.propTypes = {
    dispatch: PropTypes.func,
    store: PropTypes.object,
    kpiStatus: PropTypes.object,
    kpiStatusLoading: PropTypes.bool,
    kpiStatusError: PropTypes.bool,
    errorMessage: PropTypes.string
};

KpiEvaluationStatus.defaultProps = {
    store: {},
    kpiStatus: {},
    kpiStatusLoading: false,
    kpiStatusError: false,
    errorMessage: ""
};

export default connect(mapStateToProps)(KpiEvaluationStatus);
